// Room previews are fetched on intent, rather than alongside every packshot.
if (!customElements.get('klove-catalog')) {
  customElements.define('klove-catalog', class extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-catalog-card]').forEach(card => {
        if (card.dataset.previewReady) return;
        card.dataset.previewReady = 'true';
        const reveal = () => {
          const template = card.querySelector('[data-catalog-room]');
          if (template) template.replaceWith(template.content.cloneNode(true));
        };
        card.addEventListener('pointerenter', event => { if (event.pointerType !== 'touch') reveal(); });
        card.addEventListener('focusin', reveal);
      });
    }
  });
}
if (!customElements.get('klove-catalog-inquiry')) {
  customElements.define('klove-catalog-inquiry', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const update = () => {
        const summary = this.querySelector('[data-config-summary]');
        if (!summary) return;
        summary.textContent = [...this.querySelectorAll('[data-config-option]')]
          .filter(input => input.value.trim())
          .map(input => `${input.dataset.configLabel}: ${input.value.trim()}`).join(' · ');
      };
      this.addEventListener('input', update);
      this.addEventListener('change', update);
      update();
    }
  });
}
